import { getCurrencySymbol } from '@/lib/currency';
import { fromFloyd } from '@/lib/currency';
import { type IDirectDiscount } from '@/types/content';
import { type ILineItem } from '@/types/pricing';

export const calculateDiscount = (
	basePrice: number,
	currency: string,
	discount: IDirectDiscount,
): ILineItem | null => {
	const symbol = getCurrencySymbol(currency);
	if (discount.discountType === 'fixed') {
		const discountAmount = fromFloyd(discount.discountAmount);
		return {
			timeOfCollection: 'BOOKING',
			amount: discountAmount * -1,
			description: `${symbol}${discountAmount.toFixed(2)} Discount`,
		};
	} else if (discount.discountType === 'percentage') {
		const discountAmount = basePrice * discount.discountAmount * -1;
		return {
			timeOfCollection: 'BOOKING',
			amount: discountAmount,
			description: `${symbol}${Math.abs(discountAmount).toFixed(2)} Discount`,
		};
	} else {
		return null;
	}
};
